import type { App, Directive } from 'vue'
import { vDis } from './dis'
import { vSize } from './size'
import { vColor } from './color'
import { vAlign } from './align'
import { vTip } from './tip'
import { vLoading } from './loading'
import { vHide } from './hide'
import { vPress } from './press'

// 定义所有指令
const directives: Record<string, Directive> = {
	dis: vDis,
	size: vSize,
	color: vColor,
	align: vAlign,
	tip: vTip,
	loading: vLoading,
	hide: vHide,
	press: vPress
}

// 安装函数
const install = (app: App) => {
	// 注册所有指令
	Object.entries(directives).forEach(([name, directive]) => {
		app.directive(name, directive)
	})
}

export default {
	install
}

export { vAlign, vColor, vDis, vLoading, vSize, vTip, vHide, vPress }
